// extracted by mini-css-extract-plugin
export default {"userAvatarContainer":"style_userAvatarContainer__B6v7g","titleContainer":"style_titleContainer__Yl4Mg"};